import { NonRecurrentHypothesisTypePerMantyStatus } from './types';

/**
 * Compares two NonRecurrentHypothesisTypePerMantyStatus objects and returns an array of keys where their values differ.
 *
 * @param {NonRecurrentHypothesisTypePerMantyStatus} obj1 - The first object to compare.
 * @param {NonRecurrentHypothesisTypePerMantyStatus} newParams - The second object to compare.
 * @returns {string[]} An array of keys where the values of obj1 and obj2 are different.
 */
export const findMismatchedKeys = ({
    oldParams,
    newParams,
}: {
    oldParams: NonRecurrentHypothesisTypePerMantyStatus;
    newParams: NonRecurrentHypothesisTypePerMantyStatus;
}): (keyof NonRecurrentHypothesisTypePerMantyStatus)[] =>
    Object.keys(oldParams).reduce<
        (keyof NonRecurrentHypothesisTypePerMantyStatus)[]
    >((acc, key) => {
        if (oldParams[key] !== newParams[key]) {
            acc.push(key);
        }
        return acc;
    }, []);
